module.exports = __webpack_public_path__ + "img/connecting.ddd751c3.svg";